import { signOut } from 'firebase/auth';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat';

import { LoadingImage } from 'component-lib/atoms/LoadingImage/LoadingImage';
import { useAuthenticationContext } from 'core/context/Authentication';
import { fbAuth } from 'support/firebase/firebase';

export const Logout = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAnonymous } = useAuthenticationContext();

  const redirectPath = searchParams.get('redirect') || '/';

  useEffect(() => {
    if (!isAnonymous) signOut(fbAuth);
  }, [isAnonymous]);

  useEffect(() => {
    /**
     * We cannot do this imperatively after signOut, as we need to
     * allow time for onAuthStateChanged to finish updating
     * our user objects inside the AuthenticationContext.
     *
     * This also handles anonymous users visiting /logout though
     * we shouldn't bother logging those out and creating new users
     */
    if (isAnonymous) navigate(redirectPath, { replace: true });
  }, [isAnonymous, navigate, redirectPath]);

  return <LoadingImage />;
};
